import { connect } from 'react-redux';
// components
import EmailVerificationComponent from './email-verification.component';
// types
import { Dispatch } from 'types/dispatch';
import { State } from 'widgets/redeem/root/root.reducers';
// actions
import {
    checkIsEmailVerified,
    checkEmailVerification,
    verifyEmail,
    setCompletedVerificationStatus,
    setSentVerificationStatus
} from 'modules/email-verification/email-verification.actions';

const mapStateToProps = (state: State) => ({
    emailVerificationStatus: state.emailVerification?.emailVerificationStatus
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    checkIsEmailVerified: () => dispatch(checkIsEmailVerified()),
    checkEmailVerification: () => dispatch(checkEmailVerification()),
    verifyEmail: () => dispatch(verifyEmail()),
    setCompletedVerificationStatus: () => dispatch(setCompletedVerificationStatus()),
    setSentVerificationStatus: () => dispatch(setSentVerificationStatus())
});

export const EmailVerificationContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(EmailVerificationComponent);

export default EmailVerificationContainer;
